module.exports = __webpack_public_path__ + "img/formBG.be166214.gif";